function Name({name}){
  return(
    <div className="mt-4 h4">{name}</div>
  );
}

export default Name;
